var path = '/app/components/ui/fable-dialog/fable-dialog.html';
var html = "<div class=dialog> <div class=drag-box> <div class=drag-title>Arraste as opções corretas:</div> <div ng-repeat=\"word in $ctrl.wordsFable.drag\" class=draggable ui-draggable=true drag=\"{ data: word }\">{{word}}</div> </div> <div class=drop-box ng-bind-html=$ctrl.wordsFable.textDrop> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/fable-dialog/fable-dialog.html
// module id = 164
// module chunks = 0